import {SpanIcon} from '@mazraeapp/react_icon_kit';
import classNames from 'classnames';
import {Field} from 'formik';
import React, {ChangeEvent} from 'react';
import ChatInput from '../chatInput';

interface ChatFormTextProps {
  isOpenPopUp: boolean;
  imageUpload: React.RefObject<HTMLInputElement>;
  fileUpload: React.RefObject<HTMLInputElement>;
  chatId?: string;
  setisOpenPopUp: React.Dispatch<React.SetStateAction<boolean>>;
  handlerUploadImage: (event: ChangeEvent<HTMLInputElement>) => void;
  handlerUploadFile: (event: ChangeEvent<HTMLInputElement>) => void;
}
const ChatFormText = ({
  isOpenPopUp,
  imageUpload,
  fileUpload,
  chatId,
  setisOpenPopUp,
  handlerUploadImage,
  handlerUploadFile,
}: ChatFormTextProps) => {
  return (
    <div className="w-full flex items-center gap-2 relative">
      <Field
        className={` w-full  p-2`}
        name="text"
        placeholder="اینجا بنویسید..."
        as={ChatInput}
      />
      {chatId && (
        <button
          type="button"
          className="flex items-center"
          onClick={() => setisOpenPopUp(prev => !prev)}
        >
          <SpanIcon className="icon-namelink text-xl" />
        </button>
      )}
      <div
        className={classNames(
          'absolute flex-col text-md font-md text-gray-950 w-[211px] gap-2 p-2 bottom-[70px] left-0 bg-white shadow-xl',
          {
            flex: isOpenPopUp,
            'hidden ': !isOpenPopUp,
          },
        )}
      >
        <label
          htmlFor="image-upload"
          className="w-100 text-md flex gap-2 items-center"
        >
          <input
            ref={imageUpload}
            accept="image/png, image/gif, image/jpeg"
            id="image-upload"
            className="hidden"
            type="file"
            name="upload-image"
            onChange={handlerUploadImage}
          />

          <SpanIcon className="icon-nameImage-2 text-xl" />
          <span>گالری</span>
        </label>
        <label
          htmlFor="file-upload"
          className="w-100 text-md flex gap-2 items-center"
        >
          <input
            ref={fileUpload}
            accept="video/* ,.pdf"
            id="file-upload"
            className="hidden"
            type="file"
            name="upload-image"
            onChange={handlerUploadFile}
            capture={false}
          />
          <SpanIcon className="icon-nameDocument text-xl" />
          <span>فایل ها</span>
        </label>
      </div>
    </div>
  );
};

export default ChatFormText;
